import { Routes } from '@angular/router';

import { roleGuard } from '../../core/guards/role.guard';
import { RoleCode } from '../../shared/models/user/user.enums';
import { canLeaveGuard } from '../../core/guards/can-leave-guard/can-leave.guard';

export const requisitionsRoutes: Routes = [
	{
		path: 'requisitions',
		canActivate: [roleGuard],
		data: {
			allowedRoles: [
				RoleCode.ADMIN,
				RoleCode.SUPER_ADMIN,
				RoleCode.WAREHOUSE_PERSONNEL,
				RoleCode.SUPERVISOR,
				RoleCode.LEAD_HAND,
				RoleCode.CC_VIEWER,
				RoleCode.APPROVER
			]
		},
		children: [
			{
				path: '',
				loadComponent: () => import('./pages/requisitions/requisitions-page.component').then(c => c.RequisitionsListPageComponent)
			}
		]
	},
	{
		path: 'requisition',
		children: [
			{
				path: ':requisitionId',
				canActivate: [roleGuard],
				canDeactivate: [canLeaveGuard],
				data: {
					allowedRoles: [
						RoleCode.ADMIN,
						RoleCode.SUPER_ADMIN,
						RoleCode.WAREHOUSE_PERSONNEL,
						RoleCode.SUPERVISOR,
						RoleCode.LEAD_HAND,
						RoleCode.CC_VIEWER,
						RoleCode.APPROVER
					]
				},
				loadComponent: () => import('./pages/requisition/requisition-page.component').then(c => c.RequisitionDetailPageComponent)
			}
		]
	}
];
